import { useEffect, useRef } from 'react'
import Cookies from 'js-cookie'
import { useDispatch } from 'react-redux'
import { createNotificationSocket } from 'services/socket'
import { notificationUpserted } from 'store/notifications'

const useInvoiceNotificationFeed = ({ onNotification } = {}) => {
  const dispatch = useDispatch()
  const socketRef = useRef(null)
  const notificationHandlerRef = useRef(onNotification)

  useEffect(() => {
    notificationHandlerRef.current = onNotification
  }, [onNotification])

  useEffect(() => {
    if (socketRef.current) return
    const token = Cookies.get('sharedToken')
    if (!token) return
    const socket = createNotificationSocket(token)
    if (!socket) return
    socketRef.current = socket

    const handleNotification = payload => {
      console.log('Received invoice notification:', payload)
      dispatch(notificationUpserted(payload))
      notificationHandlerRef.current?.(payload)
    }

    socket.on('invoice_notification', handleNotification)
    socket.on('connect_error', error => {
      // eslint-disable-next-line no-console
      console.error('Notification socket connection error', error?.message || error)
    })

    return () => {
      const activeSocket = socketRef.current
      if (activeSocket) {
        activeSocket.off('invoice_notification', handleNotification)
        activeSocket.removeAllListeners()
        activeSocket.disconnect()
      }
      socketRef.current = null
    }
  }, [dispatch])
}

export default useInvoiceNotificationFeed
